module.exports = __webpack_public_path__ + "img/arrow.6a2c40d2.svg";